Pegasus.LoadingRoute = Ember.Route.extend({
  setupController: function(){
    this.controllerFor('modal').set('presenter', null);
    Pegasus.set('loaded', false);
    Pegasus.set('status', 'loading');
    //this.send('loadTemplate');
  },
  deactivate: function(){
    this._super();
    Pegasus.set('status', 'editing');
  },
  actions: {
    loadTemplate: function(){
      var template,
        hostObject;

      template = Pegasus.IOManager.createFromExternal();

      Em.run(Pegasus.stateMachine, 'send', 'contentInitialized', template);
    }
  }
});
